import type { TranslationKey } from '@/lib/i18n';

export const SIDE_CART_ACCESSIBILITY_LABEL = [
  'common:sideCart.label',
  'Shopping cart',
] as const satisfies TranslationKey;

export const SIDE_CART_FUNNEL_BANNER = [
  'common:sideCart.funnelBanner',
  'Special offer selected',
] as const satisfies TranslationKey;

export const SIDE_CART_LOADING = [
  'sidecart:cart.loading',
  'Loading cart...',
] as const satisfies TranslationKey;
